import { render, staticRenderFns } from "./OptionsSwitch.vue?vue&type=template&id=282dafac&scoped=true"
import script from "./OptionsSwitch.vue?vue&type=script&lang=js"
export * from "./OptionsSwitch.vue?vue&type=script&lang=js"
import style0 from "./OptionsSwitch.vue?vue&type=style&index=0&id=282dafac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282dafac",
  null
  
)

export default component.exports